import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// state
const state = {
  config: null,
  name: 'Lion',
  appInstance: null,
  loadpage: false,
  dark: false,
  keepPageState: false,
  imageToView: '/img/loader/image_loader.png',
  productImageToView: [],
  //orientation: window.screen.orientation.angle > 0 ? 'landscape' : 'portrait'
  orientation: 'portrait',
  messageData: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
